import React from 'react';
import SideDrawerFormContainer from '../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import { ProfileMessageInput, useProfileMessagingState } from '../../../../../../shared/ProfileMessaging';

export type SendClientsMessageSideDrawerContentProps = {
    clientProfileIds: string[];
    onClose: (force: boolean) => void;
};

const SendClientsMessageSideDrawerContent: React.FC<SendClientsMessageSideDrawerContentProps> = ({
    clientProfileIds,
    onClose,
}) => {
    const { onSend, isSendDisabled, message, setMessage, onCancel } = useProfileMessagingState({
        onCancel: () => onClose(true),
        onClose: () => onClose(true),
        selectedProfileIds: clientProfileIds,
    });

    return (
        <SideDrawerFormContainer
            onCancel={onCancel}
            onSubmit={onSend}
            isSubmitDisabled={isSendDisabled}
            isDisabled={false}
        >
            <ProfileMessageInput
                selectedProfileIds={clientProfileIds}
                message={message}
                setMessage={setMessage}
                type="client-profiles"
            />
        </SideDrawerFormContainer>
    );
};

export default React.memo(SendClientsMessageSideDrawerContent);
